import { useCallback } from "react";
import apiClient from "../services/api/client";
import { ENDPOINTS } from "../services/api/endpoints";

export default function useNotification() {
  const getAll = useCallback(async () => {
    const res = await apiClient.get(ENDPOINTS.NOTIFICATION.GET_ALL);
    return res.data;
  }, []);

  const updateStatus = useCallback(async (id, data) => {
    const res = await apiClient.put(ENDPOINTS.NOTIFICATION.UPDATE(id), data);
    return res.data;
  }, []);

  const fetchDropdownOptions = useCallback(async () => {
    try {
      const res = await apiClient.get(ENDPOINTS.NOTIFICATION.BASE + "/dropdown-options");
      return res.data || { whatsAppTemplates: [], smsTemplates: [], emailTemplates: [] };
    } catch {
      return { whatsAppTemplates: [], smsTemplates: [], emailTemplates: [] };
    }
  }, []);

  return { getAll, updateStatus, fetchDropdownOptions };
}
